import React from 'react';
import ProjectsListGroupItem from './projectsListGroupItem';
import type { SearchInputBindings } from '../../hooks/useSearchInput';
import NewsPicksBanner, {
  type NewsPicksBannerProps,
} from '../common/newsPicksBanner';

interface Props {
  order?: string | null;
  searchInputProps: SearchInputBindings;
  onClickOrder: (order: string | null) => void;
  onSubmitSearch: () => void;
  newsPicksBanner: NewsPicksBannerProps | null;
}

export default function ProjectsSelector({
  order,
  searchInputProps,
  onClickOrder,
  onSubmitSearch,
  newsPicksBanner,
}: Props) {
  return (
    <>
      <div className="list-group project-selector__navi">
        <ProjectsListGroupItem
          key="order-0"
          isActive={order === 'in_progress'}
          name="新着順"
          onClick={() => onClickOrder('in_progress')}
        />
        <ProjectsListGroupItem
          key="order-1"
          isActive={order === 'amount'}
          name="人気順"
          onClick={() => onClickOrder('amount')}
        />
        <ProjectsListGroupItem
          key="order-2"
          isActive={order == null}
          name="全て"
          onClick={() => onClickOrder(null)}
        />
      </div>
      <div className="list-group project-selector__search">
        <div className="search-wrapper">
          <form
            onSubmit={event => {
              event.preventDefault();
              onSubmitSearch();
            }}
          >
            <div className="input-group search-keyword">
              <input
                {...searchInputProps}
                type="text"
                className="form-control"
                name="keyword"
                maxLength={50}
                placeholder="キーワードで検索"
              />
              <span className="search-icon" onClick={onSubmitSearch} />
            </div>
          </form>
        </div>
      </div>
      {newsPicksBanner && (
        <NewsPicksBanner
          banner={newsPicksBanner}
          spOnly
          className="project-selector__news-picks"
        />
      )}
      <div className="project-selector__attention">
        <span>※</span>
        <span>
          募集ページについては、募集期間終了後、募集の成立不成立に関わらず事業者の要請に応じて非開示となることがあります。ご了承下さい。
        </span>
      </div>
    </>
  );
}
